import { render, staticRenderFns } from "./ProductLicenseTemplateCreate.vue?vue&type=template&id=009c7065&"
import script from "./ProductLicenseTemplateCreate.vue?vue&type=script&lang=js&"
export * from "./ProductLicenseTemplateCreate.vue?vue&type=script&lang=js&"
import style0 from "./ProductLicenseTemplateCreate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports